import type * as lazyFunctions from './lazyFunctions';
import { LazyBootModule, LazyAction } from 'owa-bundling-light';

const lazyModule: LazyBootModule<typeof lazyFunctions> = new LazyBootModule<typeof lazyFunctions>(
    () => import(/* webpackChunkName: "AppBootAccountSourceList" */ './lazyFunctions'),
    { name: 'AppBootAccountSourceList' }
);

export const lazyUpdateAccountStateBasedOnPolicyProxy: LazyAction<
    typeof lazyFunctions.lazyUpdateAccountStateBasedOnPolicy.importAndExecute,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.lazyUpdateAccountStateBasedOnPolicy.importAndExecute);

export const lazyUpdateLicensingIdentitiesStateBasedOnAccountPolicyProxy: LazyAction<
    typeof lazyFunctions.lazyUpdateLicensingIdentitiesStateBasedOnAccountPolicy.importAndExecute,
    typeof lazyModule
> = new LazyAction(
    lazyModule,
    m => m.lazyUpdateLicensingIdentitiesStateBasedOnAccountPolicy.importAndExecute
);

export const lazyEnsurePreRenderForAccountProxy: LazyAction<
    typeof lazyFunctions.lazyEnsurePreRenderForAccount.importAndExecute,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.lazyEnsurePreRenderForAccount.importAndExecute);
export const lazyAreNewAccountAndExistingAccountsMutuallyCompliantProxy: LazyAction<
    typeof lazyFunctions.lazyAreNewAccountAndExistingAccountsMutuallyCompliant.importAndExecute,
    typeof lazyModule
> = new LazyAction(
    lazyModule,
    m => m.lazyAreNewAccountAndExistingAccountsMutuallyCompliant.importAndExecute
);
export const lazyOobeInitForNewlyAddedGlobalSettingsAccountProxy: LazyAction<
    typeof lazyFunctions.lazyOobeInitForNewlyAddedGlobalSettingsAccount.importAndExecute,
    typeof lazyModule
> = new LazyAction(
    lazyModule,
    m => m.lazyOobeInitForNewlyAddedGlobalSettingsAccount.importAndExecute
);
export const lazyIsLicenseRequirementsCompliantProxy: LazyAction<
    typeof lazyFunctions.lazyIsLicenseRequirementsCompliant.importAndExecute,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.lazyIsLicenseRequirementsCompliant.importAndExecute);
export const lazyAccountSourceListPostRenderProxy: LazyAction<
    typeof lazyFunctions.lazyAccountSourceListPostRender.importAndExecute,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.lazyAccountSourceListPostRender.importAndExecute);

export const lazyAreAllAccountsPolicyAllowingConsumerAccountsProxy: LazyAction<
    typeof lazyFunctions.lazyAreAllAccountsPolicyAllowingConsumerAccounts.importAndExecute,
    typeof lazyModule
> = new LazyAction(
    lazyModule,
    m => m.lazyAreAllAccountsPolicyAllowingConsumerAccounts.importAndExecute
);
